import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header-body" }
const _hoisted_2 = { class: "header-logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "header-menu" }
const _hoisted_5 = { class: "right-content" }

import { useLocaleStore } from '@/store/locale';
import { useThemeStore } from '@/store/theme';
import { Locale } from '@varlet/ui';
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import AIPopupComponent from '../AiComponents/AIPopupComponent.vue';
import Tools from '@/utils/Tools';
import { useSystemConfigStore } from '@/store/SystemConfigStore';
import { useLocale } from '@/hooks/useLocale';
import LanguageComponent from '../GlobalComponents/LanguageComponent.vue';
import { useLanguageStatusStore } from '@/store/LanguageStatusStore';
import ClockComponent from '../GlobalComponents/ClockComponent.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const locale = useLocaleStore();
const systemConfigStore = useSystemConfigStore();
const themeStore = useThemeStore();
const languageStatusStore = useLanguageStatusStore();
const local = useLocale();
const messages = Locale.messages;

const active = ref(0);

// const menuComputed = computed()

const menus = computed(() => [
    {
        name: local.t('components.HeaderComponent.home'),
        path: '/'
    },
    {
        name: local.t('components.HeaderComponent.heyue'),
        path: '/contract'
    },
    {
        name: local.t('components.HeaderComponent.qiquan'),
        path: '/options'
    },
    {
        name: local.t('components.HeaderComponent.xianhuo'),
        path: '/transaction'
    },
    {
        name: local.t('route.me.menus.daikuan'),
        path: '/loans'
    },
    {
        name: local.t('components.HeaderComponent.wode'),
        path: '/me'
    },
    {
        name: local.t('components.HeaderComponent.about'),
        path: '/about'
    },
    // {
    //     name: local.t('components.HeaderComponent.ptjj'),
    //     path: '/introduction'
    // },
    // {
    //     name: local.t('components.HeaderComponent.dingyue'),
    //     path: '/subscribe'
    // }
]);


watch(() => route.path, (n, o) => {
    for (let i = 0; i < menus.value.length; i++) {
        if (menus.value[i].path === n) {
            active.value = i;
            return;
        }
    }
}, {
    immediate: true
});

/**
 * 跳转页面
 * @param index 
 */
function OpenMenu(index: number) {
    router.push(menus.value[index].path);
}


function SetTheme(themeKey: 'light' | 'dark') {
    themeStore.setTheme(themeKey);
}


return (_ctx: any,_cache: any) => {
  const _component_var_tab = _resolveComponent("var-tab")!
  const _component_var_tabs = _resolveComponent("var-tabs")!
  const _component_var_icon = _resolveComponent("var-icon")!
  const _component_var_button = _resolveComponent("var-button")!
  const _component_var_menu = _resolveComponent("var-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "icon",
        src: _ctx.$R(_unref(systemConfigStore).getConfig?.SystemLogo),
        style: {"width":"50px","height":"50px"},
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_var_tabs, {
        active: active.value,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus.value, (m, index) => {
            return (_openBlock(), _createBlock(_component_var_tab, {
              onClick: ($event: any) => (OpenMenu(index))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(m.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 256))
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(ClockComponent),
      _createVNode(AIPopupComponent),
      _createVNode(_component_var_button, {
        color: "transparent",
        round: "",
        text: "",
        style: {"height":"100%"}
      }, {
        default: _withCtx(() => [
          (_unref(themeStore).getThemeName == 'dark')
            ? (_openBlock(), _createBlock(_component_var_icon, {
                key: 0,
                namespace: "icon",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (SetTheme('light'))),
                name: "yejing",
                size: 20
              }))
            : (_openBlock(), _createBlock(_component_var_icon, {
                key: 1,
                namespace: "icon",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (SetTheme('dark'))),
                name: "lieri",
                size: 20
              }))
        ]),
        _: 1
      }),
      _createVNode(_component_var_menu, {
        show: _unref(languageStatusStore).show,
        "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_unref(languageStatusStore).show) = $event)),
        placement: "bottom-end",
        style: {"height":"100%"}
      }, {
        menu: _withCtx(() => [
          _createVNode(LanguageComponent)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_var_button, {
            color: "transparent",
            round: "",
            text: "",
            style: {"height":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_var_icon, {
                namespace: "icon",
                name: "duoyuyan",
                size: 20
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ]))
}
}

})